import firebase from 'firebase/app'
import 'firebase/firebase-messaging'
import store from './store'

// import {CometChat} from "@cometchat-pro/chat"


export default async function firebaseInitialize() {
    var firebaseConfig = {
        apiKey: "AIzaSyD_dcTFBrOSYUXJ9Fx0ZI7i1Eswp4AMx60",
        authDomain: "solena-mas-push-notifications.firebaseapp.com",
        projectId: "solena-mas-push-notifications",
        storageBucket: "solena-mas-push-notifications.appspot.com",
        messagingSenderId: "1085287651618",
        appId: "1:1085287651618:web:f9670734b166e7bffeed7b",
        measurementId: "G-KS7EQ8JQXE"
    }
    firebase.initializeApp(firebaseConfig)
    const messaging = firebase.messaging()

    messaging.getToken({
        vapidKey: 'BA1kqJJWoj7CAaU4CPcqwha2Vnj-fWa0ZBsY23blXb-k5v4wZEglBTHFOylv6C4U-a8wRdn_eA0H4Wv74JTY1To'
    }).then((currentToken) => {
        if (currentToken) {

            if(localStorage.getItem("tokenFirebase") == null || localStorage.getItem("tokenFirebase") == ''){
                localStorage.setItem('tokenFirebase', currentToken)
            }else if(localStorage.getItem("tokenFirebase") != currentToken){
                localStorage.setItem('tokenFirebase', currentToken)
            }

    

        } else {
            console.log('No registration token available. Request permission to generate one.');
        }
    }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
    });

    messaging.onMessage(async function (payload) {
        // console.log('Receiving foreground message');
        
        const notificationTitle = 'Solena Explore';
        const notificationOptions = {
            body: payload.data.message,
            icon: '/img/icons/apple-touch-icon.png'
        };

        var notification = new Notification(notificationTitle, notificationOptions);
        notification.onclick = function (event) {
            notification.close();
            // console.log(event);
        };

        if(payload.data.closeSession == "true"){
            
            await store.dispatch('session/logout')

            store.commit('samples/SET_SAMPLE_SELECTED', null)
            store.commit('logs/CLEAR_STATE')
            store.commit('samples/SET_SAMPLES', [])
            store.commit('samples/SET_AREA_SELECTED_SAMPLE', null)
            store.commit('areasList/SET_AREA_SELECTED', null)

            window.location.reload()
        }

        
    });

}